import { render, staticRenderFns } from "./message-intro.vue?vue&type=template&id=712786a2&scoped=true&"
import script from "./message-intro.vue?vue&type=script&lang=ts&"
export * from "./message-intro.vue?vue&type=script&lang=ts&"
import style0 from "./message-intro.vue?vue&type=style&index=0&id=712786a2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712786a2",
  null
  
)

export default component.exports